import { forwardRef, type HTMLAttributes } from "react";
import type { StudyGroupViewKey } from "./types";

export const scrollContainerKeyForView = (
  viewKey: StudyGroupViewKey,
): string => (viewKey === "events" ? "events:list" : viewKey);

export const isScrollContainerKeyForView = (
  viewKey: StudyGroupViewKey,
  containerKey: string,
): boolean => scrollContainerKeyForView(viewKey) === containerKey;

type ViewStateScrollContainerProps = HTMLAttributes<HTMLDivElement> & {
  viewKey: StudyGroupViewKey;
  isReady: boolean;
};

export const ViewStateScrollContainer = forwardRef<
  HTMLDivElement,
  ViewStateScrollContainerProps
>(({ viewKey, isReady, ...props }, ref) => (
  <div
    {...props}
    ref={ref}
    data-view-state-scroll-key={scrollContainerKeyForView(viewKey)}
    data-view-state-scroll-ready={String(isReady)}
  />
));

ViewStateScrollContainer.displayName = "ViewStateScrollContainer";
